<div
  class="star-rating-container gap-1 d-flex align-items-center"
  [attr.aria-label]="rating()"
  [class]="ratingCustomClasses()"
>
  <!-- Full Stars -->
  @for (star of [].constructor(fullStars()); track $index) {
    <span class="full-star" [innerHTML]="STAR_SVGs.FULL_STAR_SVG | safeHtml"></span>
  }

  <!-- Partial Star -->
  @if (splitStar() !== '0%') {
    <span class="partial-star" #partialStar [innerHTML]="STAR_SVGs.PARTIAL_STAR_SVG | safeHtml"></span>
  }
</div>
